module.exports = __webpack_public_path__ + "img/firstStep.f25008d7.png";